<template>
  <div class="form-select-input form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="widget.readOnly"
        @click.native="showSelectList"
      >
        <div class="select-placeholder" v-if="renderSence === 'edit'">
          <span
            v-if="!widget.readOnly && (!formValueData || (formValueData && formValueData.length === 0))"
          >{{ widget.placeholder }}</span>
          <!-- <x-tag-group v-else :tags="formValueShowList" calcKey="label" :tagMarginWidth="0">
            <template v-slot:tag="{tag}">
              <form-value-tag :tag="tag" :widget="widget"></form-value-tag>
            </template>
          </x-tag-group> -->
          <template v-else>
            <div v-for="(tag, index) of formValueShowList" :key="index" style="display: inline-block; margin-right: .4rem; margin-bottom: .4rem;">
              <form-value-tag :tag="tag" :widget="widget"></form-value-tag>
            </div>
          </template>
        </div>
        <template v-if="renderSence === 'read'">
          <div v-for="(tag, index) of formValueShowList" :key="index" style="display: inline-block; margin-right: .4rem; margin-bottom: .4rem;">
            <form-value-tag :tag="tag" :widget="widget"></form-value-tag>
          </div>
        </template>
        <!-- <form-value-tag
          v-if="renderSence === 'read'"
          :formValueShowList="formValueShowList"
          :widget="widget"
        ></form-value-tag> -->
      </x-proxy-form-item>
      <div v-if="!widget.readOnly && (formValueData && formValueData.length > 0)" class="form-select-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }" @click="clear">
        <x-svg-icon
          class="arrow-right"
          name="clear"
        ></x-svg-icon>
      </div>
      <div v-else-if="!widget.readOnly" class="form-select-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }" @click="showSelectList">
        <x-svg-icon class="arrow-right" name="arrow-right-icon"></x-svg-icon>
      </div>
      <!-- <x-svg-icon
        v-if="!widget.readOnly && (formValueData && formValueData.length > 0)"
        class="arrow-right"
        name="clear"
        @click.native="clear"
      ></x-svg-icon>
      <x-svg-icon v-else-if="!widget.readOnly" class="arrow-right" name="arrow-right-icon" @click.native="showSelectList"></x-svg-icon> -->
    </div>
    <form-select-drawer
      ref="formSelectDrawerRef"
      :widget="widget"
      :chooseOptions="chooseOptions"
      @okEvent="okEvent"
    ></form-select-drawer>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import FormValueTag from './form-value-tag/form-value-tag'
import FormSelectDrawer from './form-select-drawer/form-select-drawer'

export default {
  name: 'FormValueSelect',
  mixins: [FormWidgetConfigMixin],
  components: {
    FormValueTag,
    FormSelectDrawer
  },
  computed: {
    formValueShowList: function() {
      let arr = []
      if (this.formValue && this.formValue.length > 0) {
        if (this.widget.chooseType === 'MULTI') {
          this.widget.chooseOptions.forEach((item) => {
            this.formValue.forEach((id) => {
              if (id === item.id) {
                arr.push(item)
              }
            })
          })
        } else {
          if (typeof this.formValue === 'string') {
            arr = this.widget.chooseOptions.filter((item) => item.id === this.formValue)
          } else {
            this.widget.chooseOptions.forEach((item) => {
              this.formValue.forEach((id) => {
                if (id === item.id) {
                  arr.push(item)
                }
              })
            })
          }
        }
      }
      return arr
    },
    formValueData: {
      get() {
        if (this.formValue instanceof Array) {
          const arr = this.formValue.filter(id => {
            let idTag = null
            this.chooseOptions.forEach(item => {
              if (id === item.id) {
                idTag = id
              }
            })
            if (idTag) {
              return idTag
            }
          })
          console.log(this.chooseOptions)
          console.log(arr)
          return arr.filter(item => item)
        } else {
          if (this.formValue) {
            return [this.formValue]
          }
        }
      },
      set(value) {
        if (value) {
          this.formValue = value
        } else {
          this.formValue = undefined
        }
      }
    },
    chooseOptions: function() {
      if (this.widget.chooseOptions && this.widget.chooseOptions.length > 0) {
        return this.widget.chooseOptions.filter((item) => item.label && item.status === 'ENABLE')
      } else {
        return []
      }
    }
  },
  methods: {
    showSelectList() {
      if (this.renderSence === 'edit' && !this.widget.readOnly) {
        this.$nextTick(() => {
          this.$refs.formSelectDrawerRef.open(this.formValueData)
        })
      }
    },
    clear() {
      this.formValue = []
    },
    okEvent(data) {
      if (data && data.length > 0) {
        this.formValueData = data
      } else {
        this.formValueData = []
      }
    }
  }
}
</script>

<style lang="scss">
.form-select-input {
  .form-item-content {
    z-index: 1;
    position: relative;

    .select-read-tag {
      margin-bottom: 0 !important;
      margin-right: 0 !important;
    }
    .select-placeholder {
      color: $--app-notice-color;
      padding-right: 1.46rem;
    }

    .readonly-background {
      background-color: $--app-form-readonly-bgColor !important;

      .cube-input-field {
        background-color: $--app-form-readonly-bgColor !important;
        color: $--app-base-font-color !important;
      }
    }
    .form-select-suffix {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.43rem;
      height: calc(100% - 1.71rem);
      &.full-height {
        height: 100%;
      }

      .arrow-right {
        display: flex;
        align-items: center;
        color: $--app-notice-color;
      }
    }
    .tag-group-box {
      // max-width: 95%;
      width: 100%;
    }
  }
}
</style>